import { render, staticRenderFns } from "./BundleProduct.vue?vue&type=template&id=4ff06226&scoped=true&"
import script from "./BundleProduct.vue?vue&type=script&lang=js&"
export * from "./BundleProduct.vue?vue&type=script&lang=js&"
import style0 from "./BundleProduct.vue?vue&type=style&index=0&id=4ff06226&lang=scss&scoped=true&"
import style1 from "./BundleProduct.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff06226",
  null
  
)

export default component.exports